import { NgModule } from '@angular/core';
import { TraversableListDirective } from 'components/accordion/workitem-list/shared/traversable-list/traversable-list.directive';

@NgModule({
  declarations: [
    TraversableListDirective
  ],
  exports: [
    TraversableListDirective
  ]
})
export class TraversableListModule {}
